<template>
  <div id="app" >
    <router-view   />
  </div>
</template>

<script>
export default {
  name: 'App',
created() {
    document.title='铜陵市企业云服务智慧平台'
}
}
</script>

<style>
  .hide .el-upload--picture-card {
    display: none !important;
  }
  html {
    /*overflow-x:auto;*/
    /*overflow-y:scroll;*/
    font-family:Microsoft YaHei;
    /*user-select:none;*/
  }
  body, dl, dt, dd, ul, ol, li, pre, form, fieldset, input, p, blockquote, th, td {
    font-weight:400;
    margin:0;
    padding:0;
    color: #262626;
  }
  body{
    padding-right:0 !important
  }
  h1, h2, h3, h4, h4, h5 {
    margin:0;
    padding:0;
  }
  body {
    background-color:#FFFFFF;
    color:#262626;
    text-align:left;
    font-family:Microsoft YaHei;
  }
  select {
    font-size:12px;
  }
  a{
    text-decoration: none;
    color: #262626;
  }
  table {
    border-collapse:collapse;
  }
  fieldset, img {
    border:0 none;
  }
  fieldset {
    margin:0;
    padding:0;
  }
  fieldset p {
    margin:0;
    padding:0 0 0 8px;
  }
  legend {
    display:none;
  }
  address, caption, em, strong, th, i {
    font-style:normal;

  }
  table caption {
    margin-left:-1px;
  }
  hr {
    border-bottom:1px solid #FFFFFF;
    border-top:1px solid #E4E4E4;
    border-width:1px 0;
    clear:both;
    height:2px;
    margin:5px 0;
    overflow:hidden;
  }
  ol, ul {
    list-style-image:none;
    list-style-position:outside;
    list-style-type:none;
  }
  caption, th {
    text-align:left;
  }
  q:before, q:after, blockquote:before, blockquote:after {
    content:"";
  }
    .el-dialog__header {
    padding: 20px 20px 10px;
    background-color: #fff !important;
}
  /* 更多下拉样式 */
  /deep/.el-dropdown {
      padding: 5px 10px;
      display: inline-block;
      position: relative;
      color: #606266;
      font-size: 14px;
  }
  .el-dropdown-menu--mini .el-dropdown-menu__item {
      line-height: 24px;
      width: 80px;
      padding: 5px 10px;
      font-size: 14px !important;
  }
 .el-button--mini{
    font-size: 16px !important;
  }
  .cell{
    font-size: 16px !important;
  }
  /*.el-button{*/
  /*  font-size: 16px !important;*/
  /*}*/
/*  选项卡字体大小*/
  .el-tabs__item{
    font-size: 16px !important;
  }
  /* 全局图片上传(上传图片样式) */
  .el-upload-list--picture-card .el-upload-list__item {
    overflow: hidden;
    margin: -30px 0px 0px 118px !important;
    background-color: #fff;
    border: 1px solid #c0ccda;
    border-radius: 6px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 90px;
    height: 90px;
    display: block;
  }
  .el-upload-list--picture-card .el-upload-list__item-thumbnail {
    width: 100%;
    height: 100%;
  }
  .el-table{
    font-size: 16px !important;
  }
  .el-form--inline .el-form-item__label {
    float: none;
    display: inline-block;
    font-size: 14px;
    font-weight: bolder;
  }
   /* 全局图片上传(上传图片样式) */
  .el-upload--picture-card {
    background-color: #fbfdff;
    border: 1px dashed #c0ccda;
    border-radius: 6px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 40px !important;
    height: 40px !important;
    margin: -40px 0px 0px 118px;
    line-height: 50px;
    display: block;
  }
  .el-upload-list--picture-card .el-upload-list__item {
    overflow: hidden;
    margin: -30px 0px 0px 118px !important;
    background-color: #fff;
    border: 1px solid #c0ccda;
    border-radius: 6px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 90px;
    height: 90px;
    display: block;
  }
  .el-upload-list--picture-card .el-upload-list__item-thumbnail {
    width: 100%;
    height: 100%;
  }
  .el-table{
    font-size: 16px !important;
  }
  .el-form--inline .el-form-item__label {
    float: none;
    display: inline-block;
    font-size: 14px;
    font-weight: bolder;
  }
/*  表格样式*/
/*  .el-table {*/
/*    -ms-flex: none !important;*/
/*    flex: none !important;*/
/*    width: max-content;*/
/*  }*/
</style>



// WEBPACK FOOTER //
// src/App.vue